// Lazy load below-fold images in essay content
// First image is left eager (may be above the fold)
const lazyImages = () => {
  const contentImages = document.querySelectorAll('.gh-content img');
  contentImages.forEach((img, i) => {
    if (i > 0) {
      img.loading = 'lazy';
    }
  });
};

export default lazyImages;
